import { PaymentFormField } from 'react-easyrocket';

export const isFilledUp = (formFields: PaymentFormField[], defaultValues: Readonly<object>) => {
  const values = defaultValues as Readonly<Record<string, string>>;
  return formFields.every((field) => {
    if (field.toShow === false || field.name === 'dialingCode') return true;
    const value = values[field.name];
    return Boolean(value && value.trim());
  });
};
